import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import {
  EMPTY_FUNCTION,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../../constants/common'
import {
  HTML_ELEMENT_TAB_INDEX_NOT_TABABLE,
  HTML_ELEMENT_TAB_INDEX_TABABLE,
} from '../../../../constants/html'
import { AIButtonContainedDark, AIButtonTextGrey } from '../../../AIButton'
import { BUTTON_HEIGHT_24 } from '../../../Button'
import { GRETA_AI_CHAT_SOURCE_TEXT_KEYS } from '../../GretaAIChat.constants'
import { QA_NAME_GRETA_AI_CHAT_SOURCE_SWITCH_OPTION } from '../GretaAIChatSourceSwitch.constants'
import { getGretaAIChatSourceSwitchPinnedTooltipKey } from '../GretaAIChatSourceSwitch.utils'

import * as styles from './GretaAIChatSourceSwitchOption.module.css'

function GretaAIChatSourceSwitchOption({
  canSwitch = false,
  isFinanceNotBought = false,
  isPinned = false,
  keyboardSelectRef,
  selectedSource,
  source,
  onKeyDown = EMPTY_FUNCTION,
  onSelect = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  const buttonRef = useRef(null)

  const isSelected = source === selectedSource

  // The selected option is a different button, so focus moves once it has rendered.
  useEffect(() => {
    if (isSelected && keyboardSelectRef.current) {
      keyboardSelectRef.current = false
      buttonRef.current?.focus()
    }
  }, [isSelected])

  const { shortKey } = GRETA_AI_CHAT_SOURCE_TEXT_KEYS[source]

  const pinnedTooltipKey = getGretaAIChatSourceSwitchPinnedTooltipKey({
    isFinanceNotBought,
    isPinned,
    option: source,
    source: selectedSource,
  })

  const Option = isSelected ? AIButtonContainedDark : AIButtonTextGrey

  const optionClassName = isSelected ? styles.selected : styles.option

  const isDisabled = !isSelected && !canSwitch

  const tabIndex = isSelected
    ? HTML_ELEMENT_TAB_INDEX_TABABLE
    : HTML_ELEMENT_TAB_INDEX_NOT_TABABLE

  const tooltip = pinnedTooltipKey ? t(pinnedTooltipKey) : null

  function handleClick() {
    if (!isSelected) {
      onSelect(source)
    }
  }

  return (
    <Option
      className={optionClassName}
      disabled={isDisabled}
      elementRef={buttonRef}
      height={BUTTON_HEIGHT_24}
      qaName={QA_NAME_GRETA_AI_CHAT_SOURCE_SWITCH_OPTION[source]}
      tabIndex={tabIndex}
      text={t(shortKey)}
      tooltip={tooltip}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
      onKeyDown={onKeyDown}
    />
  )
}

export default GretaAIChatSourceSwitchOption
